export default __webpack_public_path__ + "static/media/logo-light.1daaf742.svg";